import React from "react";
import { Box, Typography } from "@mui/material";

const Tooltip = () => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-block",
        textAlign: "center",
        
      }}
    >
      {/* Tooltip Content */}
      <Box
        sx={{
          width: "80px",
          display: "grid",
          placeItems: "center",
          position: "absolute",
          top: "-88px",
          left: "50%",
          marginLeft: "70px",
          transform: "translateX(-50%)",
          backgroundColor: "#FFD700",
          color: "#000",
          fontWeight: "bold",
           padding: "7px 13px",
          borderRadius: "12px",
          fontSize: "12px",
          fontFamily: "'Roboto', sans-serif",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          zIndex: 10,
        }}
      >
        Save 15%
        {/* Tooltip Arrow */}
        <Box
          sx={{
            position: "absolute",
            bottom: "-6px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "0",
            height: "0",
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderTop: "8px solid #FFD700",
          }}
        />
      </Box>
    </Box>
  );
};

export default Tooltip;
